import { render, staticRenderFns } from "./Cadeira.vue?vue&type=template&id=26816268&"
import script from "./Cadeira.vue?vue&type=script&lang=js&"
export * from "./Cadeira.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports